import { TaxAgentService } from '../../providers'

const TaxAgentModule = {
  namespaced: true,
  state: {
    taxAgent: {
      id: 0,
      company: {},
      remark: '',
      status: 'pending',
      taxAgentDocument: [],
      created_at: '',
      updated_at: ''
    }
  },
  mutations: {
    SET_TAX_AGENT (state, data) {
      state.taxAgent = data
    },
    SET_TAX_AGENT_DOCUMENT (state, data) {
      state.taxAgent.taxAgentDocument = data
    }
  },
  actions: {
    async createTaxAgent (_context, data) {
      const result = await TaxAgentService.createTaxAgent(data)
      return result
    },
    async getTaxAgentByTaxId ({ commit }, taxId) {
      const result = await TaxAgentService.getTaxAgentByTaxId(taxId)
      commit('SET_TAX_AGENT', result?.data)
      return result
    },
    async setTaxAgent ({ commit }, data) {
      commit('SET_TAX_AGENT', data)
    },
    async updateTaxAgent (_context, { id, data }) {
      const result = await TaxAgentService.updateTaxAgent(id, data)
      return result
    }
  }
}

export default TaxAgentModule
